export default __webpack_public_path__ + "navigation-examples-custom-banner-960-c1de6df97d9ef78c7204d5695d3e6c97.webp";